import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function CounterStyles(params = {}) {
    return {
        "& .counter": {
            fontStretch: "expanded",
        },
    };
}

/**
 *
 * @param {*} props { value: 1500000, format: "read", fade: true }
 * @returns
 */
export default function Counter(props) {
    const refRoot = React.useRef(null);
    const LI = useLoremIpsum();

    const Units = {
        number: null,
        currency: " USD",
        percent: "%",
    };

    const number = props.number;
    const unit = props.unit;

    React.useEffect(() => {
        if (!props.fade || !/^\d+$/.test(number.toString()) || !refRoot.current) {
            return;
        }

        if (window.IntersectionObserver) {
            let faded = false;
            new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (!faded && entry.isIntersecting) {
                            faded = true;
                            fade();
                        }
                    });
                },
                { root: null, rootMargin: "0px", threshold: 0.5 }
            ).observe(refRoot.current);
        } else {
            fade();
        }
    }, [number, props.fade, refRoot]);

    function fade() {
        let start, progress, value;
        const duration = 5000;
        // const easing = (x) => 1 - Math.pow(1 - x, 2);
        const easing = x => Math.sin((x * Math.PI) / 2);
        window.requestAnimationFrame(function render(timestamp) {
            if (refRoot.current) {
                const text = (refRoot.current.text =
                    refRoot.current.text ?? refRoot.current.querySelector(".counter-text"));
                start = start ?? timestamp;
                progress = easing(Math.min(1, (timestamp - start) / duration));
                value = Math.round(number * progress);
                text.textContent = format(value, props.format);
            }

            progress < 1 && window.requestAnimationFrame(render);
        });
    }

    function format(number, type) {
        if (!number) {
            number = LI.Numbers[0].number;
        }

        if (type === "read") {
            const result = [];
            const reversed = number.toString().split("").reverse().join("");
            for (let i = 0; i < reversed.length; i += 3) {
                result.push(reversed.slice(i, i + 3));
            }
            return result.join(" ").toString().split("").reverse().join("");
        }

        return number;
    }
    const text = format(number, props.format);

    const elProps = toElementProps(props, { className: ["counter"] });

    return (
        <div ref={refRoot} {...elProps}>
            <span className="counter-text">{text}</span>
            <small>{unit && Units[unit]}</small>
        </div>
    );
}
